module.exports = __webpack_public_path__ + "media/images/default_profile_pic-6a3966fb7a834f454712c4596dd67d99.svg";